import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
}

interface Props {
  disabled?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 15px;
  border-radius: 6px;
  background-color: white;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
  ${(props) => props.border && 'border: 1px solid rgba(128, 128, 128, 0.6);'}
`;

export const Label = styled.label`
  min-width: 200px;
  color: ${(props) => props.theme.colors.darkGray};
  font-weight: 500;

  @media (max-width: 975px) {
    min-width: fit-content;
  }
`;

export const Input = styled.div<Props>`
  display: none;
  border: none;
  width: fit-content;
  padding: 10px;
  display: flex;
  align-items: center;
  outline: none;
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.background};
  color: black;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  cursor: ${(props) => props.disabled && 'not-allowed'};

  &:hover {
  }
`;

export const FileAddContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const Thumbnail = styled.video`
  height: 38px;
  cursor: pointer;
`;

export const Edit = styled.label`
  svg {
    font-size: 20px;
  }

  cursor: pointer;
  transition: all 0.1s;

  &:hover {
    transform: scale(1.5);
  }
`;
